/**
 *
 * UserFilter
 *
 */

import { Col, Input, Row } from 'antd';

import { Group } from 'containers/GroupDetailsPage/types';
import { PermissionGroup } from 'utils/permissionMap';
import React from 'react';
import Select from 'components/Select/Select';
import { debounce } from 'lodash';
import messages from './messages';
import styled from 'styled-components';
import translations from 'translations';

// import styled from 'styles/styled-components';
const { Search } = Input;

interface OwnProps {
  filter: any;
  groups: Group[];
  permissionGroups: PermissionGroup[];
  onSearch: (data) => void;
}

const Container = styled.div`
  .ant-btn.ant-input-search-button {
    font-size: 24px;
    padding-left: 12px;
    padding-right: 12px;
  }
  .ant-input-affix-wrapper .ant-input:not(:first-child) {
    padding-left: 50px;
  }
`;

class UserFilter extends React.Component<OwnProps> {
  public state = {
    searchBy: this.props.filter,
  };

  public onApplySearch = debounce((data) => {
    this.props.onSearch(data);
  }, 1600);

  public onChange = (key) => (event) => {
    this.setState({ searchBy: { ...this.state.searchBy, [key]: event.target ? event.target.value : event } });

    this.onApplySearch.cancel();
    this.onApplySearch({
      ...this.state.searchBy,
      [key]: event.target ? event.target.value : event,
    });
  };

  public render() {
    const { searchBy } = this.state;
    return (
      <Container>
        <Row gutter={20}>
          <Col span={7}>
            <Search
              enterButton
              placeholder={translations(messages.searchUser)}
              value={searchBy.query}
              onChange={this.onChange('query')}
              size="large"
            />
          </Col>
          <Col span={8}>
            <Select
              style={{ width: '100%' }}
              placeholder={translations(messages.filterByGroup)}
              value={searchBy.groups}
              onChange={this.onChange('groups')}
              mode="multiple"
              items={this.props.groups.map((g) => ({ value: g.groupId, label: g.name }))}
              allowClear
              size="large"
            />
          </Col>
          <Col span={9}>
            <Select
              style={{ width: '100%' }}
              placeholder={translations(messages.filterByPermissions)}
              value={searchBy.permissions}
              onChange={this.onChange('permissions')}
              mode="multiple"
              items={this.props.permissionGroups.map((p) => ({ value: p.id, label: p.title }))}
              allowClear
              size="large"
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default UserFilter;
